module.exports = __webpack_public_path__ + "eafa9364547056e174a1c9bdd10b86aa.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/thong-tin-thuong-mai.svg
// module id = ./assets/images/thong-tin-thuong-mai.svg
// module chunks = 0